<div class="col-auto m-1">
  <app-client-select
    [placeholder]="label"
    [multiple]="multiple"
    [disabled]="disabled"
    [autoLoad]="true"
    [(selectedIds)]="selectedClientIds"
    [(selectedId)]="selectedClientId"
    (changed)="onChange()"
  />
</div>
